import axios from 'axios';

// Create a centralized Axios client instance
const client = axios.create({
  baseURL: '', // Relative base URL resolves using the local host/proxy configuration
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor: Automatically inject Authorization token from localStorage
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor: Handle common response outcomes globally (e.g. 401 session expiration)
client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear all authentication credentials on session expiration
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user_name');
      localStorage.removeItem('user_email');
      localStorage.removeItem('user_picture');
      localStorage.removeItem('reply');
      
      // Optionally trigger reload or redirect if appropriate
      if (typeof window !== 'undefined') {
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export default client;
